import React, { useEffect, useState } from 'react';
import { Container, Grid, Segment, Header, Checkbox } from 'semantic-ui-react';
import { useCurrentUser } from '../../_services/hooks';

export const BetaFeatures = () => {
  const { currentUser } = useCurrentUser();

  const [voiceEnabled, setVoiceEnabled] = useState(false);
  const [command, setCommand] = useState('');

  const onPartialSpeech = text => {
    setCommand(text);
  };

  const onFinalSpeech = text => {
    setCommand(text);
  };

  useEffect(() => {
    setVoiceEnabled(localStorage.getItem('voiceEnabled') === 'true');
  }, []);

  useEffect(() => {
    if (voiceEnabled) {
      global.speech.init(onPartialSpeech, onFinalSpeech);
      global.speech.enable(true);
    } else {
      global.speech.enable(false);
    }
  }, [voiceEnabled]);

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div
        style={{
          backgroundImage: "url('/images/background.jpg')"
        }}
        className="bgimage-app fade-in"
      />
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <Segment>
              <Grid columns={1} divided stackable>
                <Grid.Row>
                  <Grid.Column>
                    <Header
                      sub
                      color="grey"
                      as="h3"
                      style={{ marginBottom: '10px' }}
                    >
                      New & Exciting! (i.e. very flaky) Features
                    </Header>
                    <Checkbox
                      toggle
                      label="Hey Carol!"
                      name="allowVoice"
                      checked={voiceEnabled}
                      onChange={e => {
                        setVoiceEnabled(!voiceEnabled);
                        localStorage.setItem('voiceEnabled', !voiceEnabled);
                      }}
                    />
                    <br />
                    <br />
                    {voiceEnabled && <p>Listening... "{command}"</p>}
                    <br />
                    Say "Hey Carol!" and a voice command such as:
                    <br />
                    <br />
                    "What's happening on Milton Avenue?"
                    <br />
                    <br />
                    "Go to Parliament Hill."
                    <br />
                    <br />
                    "Are there are any alerts?"
                    <br />
                    <br />
                    "Show me the charging sessions."
                    <br />
                    <br />
                    "Take me to the dashboard"
                    <br />
                    <br />
                    "List the hydras?"
                    <br />
                    <br />
                    "Can I see our customers?"
                    <br />
                    <br />
                    "Go to the map."
                    <br />
                    <br />
                    "What's the weather looking like?"
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
